import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from 'state/ui';
import actionTypes from 'state/ui/actionTypes';
import { delay } from 'redux-saga';

function* handleSetFormTooltip({ payload }) {
  const { key, content, delay: delayMs } = payload;
  yield put(actions.changeFormTooltipsData({ [key]: content }));
  if (delayMs) {
    yield call(delay, delayMs);
    yield put(actions.clearFormTooltip({ key }));
  }
}

export default function* () {
  yield takeEvery(actionTypes.setFormTooltip$, handleSetFormTooltip);
}
